export default __webpack_public_path__ + "cc32dd36566679a1a7986aec640e7407.png";